import { logError } from 'src/loggingManager';
import { RenderingSDK } from '@rendering/web-client';

export interface FinishData {
    id: string;
    name: string;
    scene: {
        channel: string;
        baseTexture: {
            url: string;
            dpi?: number;
        };
        bumpScale: number;
    };
}

export const getFinishList = async (sdk: RenderingSDK): Promise<FinishData[]> => {
    return sdk.Materials.getFinishesAll()
        .then((res) => res.filter((finish) => !!finish.scene))
        .catch((e) => {
            const errorMsg = `Unable to retrieve finish list: ${e}`;
            logError(errorMsg);
            throw Error(errorMsg);
        });
};
